import React from 'react';
import "./footer.css";
import { dom } from '@fortawesome/fontawesome-svg-core';



dom.watch()

function Footer(){ 
    return(
        <div>

            
            <footer>


               
               <div className="footer1">

                    <div className="div1">
                         <div className="d">
                             *Listed pricing is Maximum Retail Price (inclusive of all taxes).
                         </div>
                         <ol>
                             <li>1. Qualified purchasers receive promotion savings when they purchase an eligible Mac or eligible iPad with eligible AirPods at a qualifying location. Only one promotion product per eligible Mac or eligible iPad per qualified purchaser. Offer is subject to availability. While stocks last. Subject to terms and conditions herein.</li>
                             <li>2. Not all content is available in Dolby Atmos. Accessing Dolby Atmos features requires Dolby Atmos–capable devices. Playback quality will depend on hardware, audio accessories and Internet connection.</li>
                             <li className="li3">Apple TV+ is ₹99/month after free trial. One subscription per Family Sharing group. Offer is valid for 3 months after eligible device activation. Plan automatically renews until cancelled. Restrictions and other terms apply.</li>
                         </ol>
                    </div>

               </div>
               <div className="footer2">
                   
                    <div className="footer-ul">
                       
                       <ul>
                         <li><h4>Shop and Learn</h4></li>
                         <li><a href="# ">Mac</a></li>
                         <li><a href="# ">iPad</a></li>
                         <li><a href="# ">iPhone</a></li>
                         <li><a href="# ">Watch</a></li>
                         <li><a href="# ">TV</a></li>
                         <li><a href="# ">Music</a></li>
                         <li><a href="# ">AirPods</a></li>
                         <li><a href="# ">HomePod Mini</a></li>
                         <li><a href="# ">iPod touch</a></li>
                         <li><a href="# ">AirTag</a></li>
                         <li><a href="# ">Accessories</a></li>
                       </ul>
                       
                       <ul className="ulsub">
                         <li><h4>Services</h4></li>
                         <li><a href="# ">Apple Music</a></li>
                         <li><a href="# ">Apple TV+</a></li>
                         <li><a href="# ">Apple Arcade</a></li>
                         <li><a href="# ">iCloud</a></li>
                         <li><a href="# ">Apple One</a></li>
                         <li><a href="# ">Apple Books</a></li>
                         <li><a href="# ">Apple Podcasts</a></li>
                         <li><a href="# ">App Store</a></li>

                         <li className="ul2"><h4>Account</h4></li>
                         <li><a href="# ">Manage Your Apple ID</a></li>
                         <li><a href="# ">Apple Store Account</a></li>
                         <li><a href="# ">iCloud.com</a></li>
                       </ul>
                       
                       
                       <ul className="ulsub">
                         <li><h4>Apple Store</h4></li>
                         <li><a href="# ">Shop Online</a></li>
                         <li><a href="# ">Ways to Buy</a></li>
                         <li><a href="# ">Apple Trade In</a></li>
                         <li><a href="# ">Recycling Programme</a></li>
                         <li><a href="# ">Order Status</a></li>
                         <li><a href="# ">Shopping Help</a></li>
                       </ul>

                       
                       <ul className="ulsub">
                         <li><h4>For Business</h4></li>
                         <li><a href="# ">Apple and Business</a></li>

                         <li className="ul2"><h4>For Education</h4></li>
                         <li><a href="# ">Apple and Education</a></li>
                         <li><a href="# ">Shop for Education</a></li>
                         <li><a href="# ">Shop for University</a></li>

                         <li className="ul2"><h4>For Healthcare</h4></li>
                         <li><a href="# ">Apple in Healthcare</a></li>
                         <li><a href="# ">Health on Apple Watch</a></li>
                       </ul>

                       <ul className="ulsub">
                         <li><h4>Apple Values</h4></li>
                         <li><a href="# ">Accessibility</a></li>
                         <li><a href="# ">Environment</a></li>
                         <li><a href="# ">Privacy</a></li>
                         <li><a href="# ">Supplier Responsibility</a></li>

                         <li className="ul2"><h4>About Apple</h4></li>
                         <li><a href="# ">Newsroom</a></li>
                         <li><a href="# ">Apple Leadership</a></li>
                         <li><a href="# ">Careeer Opportunities</a></li>
                         <li><a href="# ">Investors</a></li>
                         <li><a href="# ">Ethics & Compliance</a></li>
                         <li><a href="# ">Events</a></li>
                         <li><a href="# ">Contact Apple</a></li>
                       </ul>

                       <ul uk-accordion= "multiple: true" className="god">
                           <li className='l1'>
                               <h5 className="uk-accordion-title">Shop and Learn</h5>
                               <div className="uk-accordion-content">
                                   <p><a href="# ">iPad</a></p>
                                   <p><a href="# ">iPhone</a></p>
                                   <p><a href="# ">Mac</a></p>
                                   <p><a href="# ">Watch</a></p>
                                   <p><a href="# ">TV</a></p>
                                   <p><a href="# ">Music</a></p>
                                   <p><a href="# ">AirPods</a></p>
                                   <p><a href="# ">HomePod Mini</a></p>
                                   <p><a href="# ">iPod touch</a></p>
                                   <p><a href="# ">AirTag</a></p>
                                   <p><a href="# ">Accessories</a></p>
                               </div>
                           </li>
                           <li className='l2'>
                               <h5 class="uk-accordion-title">Services</h5>
                               <div class="uk-accordion-content">
                                   <p><a href="# ">Apple Music</a></p>
                                   <p><a href="# ">Apple TV+</a></p>
                                   <p><a href="# ">Apple Arcade</a></p>
                                   <p><a href="# ">iCloud</a></p>
                                   <p><a href="# ">Apple One</a></p>
                                   <p><a href="# ">Apple Books</a></p>
                                   <p><a href="# ">Apple Podcasts</a></p>
                                   <p><a href="# ">App Store</a></p>
                               </div>
                           </li>
                           <li className='3'>
                               <h5 class="uk-accordion-title">Account</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Manage Your Apple ID</a></p>
                                    <p><a href="# ">Apple Store Account</a></p>
                                    <p><a href="# ">iCloud.com</a></p>
                               </div>
                           </li>
                           <li className='4'>
                               <h5 class="uk-accordion-title">Apple Store</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Shop Online</a></p>
                                    <p><a href="# ">Ways to Buy</a></p>
                                    <p><a href="# ">Apple Trade In</a></p>
                                    <p><a href="# ">Recycling Programme</a></p>
                                    <p><a href="# ">Order Status</a></p>
                                    <p><a href="# ">Shopping Help</a></p>
                                   
                               </div>
                           </li>

                           <li className='5'>
                               <h5 class="uk-accordion-title">For Business</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Apple and Business</a></p>           
                               </div>
                           </li>

                           <li className='6'>
                               <h5 class="uk-accordion-title">For Education</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Apple and Education</a></p>
                                    <p><a href="# ">Shop for Education</a></p>
                                    <p><a href="# ">Shop for University</a></p>         
                               </div>
                           </li>

                           <li className='7'>
                               <h5 class="uk-accordion-title">For Healthcare</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Apple in Healthcare</a></p>
                                    <p><a href="# ">Health on Apple Watch</a></p>
                                </div>
                           </li>

                           <li className='8'>
                               <h5 class="uk-accordion-title">Apple Values</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Accessibility</a></p>           
                                    <p><a href="# ">Environment</a></p>           
                                    <p><a href="# ">Privacy</a></p>           
                                    <p><a href="# ">Supplier Responsibility</a></p>           
                               </div>
                           </li>

                           <li className='9'>
                               <h5 class="uk-accordion-title">About Apple</h5>
                               <div class="uk-accordion-content">
                                    <p><a href="# ">Newsroom</a></p>           
                                    <p><a href="# ">Apple Leadership</a></p>           
                                    <p><a href="# ">Careeer Opportunities</a></p>           
                                    <p><a href="# ">Investors</a></p>           
                                    <p><a href="# ">Ethics & Compliance</a></p>           
                                    <p><a href="# ">Events</a></p>           
                                    <p><a href="# ">Contact Apple</a></p>           
                               </div>
                           </li>
    

                        </ul>
                       
                    </div>

                    <div className="more">
                        <p>More ways to shop: <a href="# "> Find a retailer</a> near you. Or call 000800 040 1966</p>
                        <p className="pindia">india</p>
                    </div>

                    <div className="footer-copy">
                        <p>Copyright © 2021 Apple Inc. All rights reserved.</p>
                        <ul>
                          <li><a href="# ">Privacy Policy</a></li>
                          <li><a href="# ">Terms of Use</a></li>
                          <li><a href="# ">Sales Policy</a></li>
                          <li><a href="# ">Sitemap</a></li>
                        </ul>
                        <div id="india">India</div>
                        
                    </div>

               </div>
            </footer>
            
        </div>
    );
}

export default Footer;